import type { FaireProductEntity } from "../../entity_types/product";

export const p_avdqv6w9sg: FaireProductEntity = {
  token: "p_avdqv6w9sg",
  type: "product",
  name: "Premier Partner Display Rack",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/8d3f1659e1d3ce7bdfe38881a6f0c3f26922d69b0aeaa10e34b7a08a8fbe038f.png",
  galleryImageUrls: [],
  priceDollars: 968.59,
  description:
    'Boost your snacking set with the Mavuno Harvest Premier Partner Display, a complete, ready-to-sell bundle designed to maximize visibility and sell-through.\n\nThis listing includes our full retail assortment—2 cases of each of our 18 retail-sized SKUs—plus a branded, dual-sided floor display rack included at no additional cost.\n\nThe free-standing rack features 15 hooks per side (30 total) and holds 120–180 bags of product, all within a compact 18" x 19" footprint. It’s ideal for impulse zones, cafés, or high-traffic areas where space is limited but impact matters.\n\nWhat’s included in this bundle:\n\n-2 cases of each of 18 retail SKUs (36 total cases)\n-1 branded, dual-sided floor display rack (FREE)\n-30 total hooks (15 per side)\n-Capacity for 4–6 bags per hook\n\nPricing:\nThe $699 price reflects the cost of the inventory only. The display rack is included free as a thank-you for partnering with Mavuno Harvest.\n\nThis bundle is perfect for retailers looking to launch or expand a strong Mavuno Harvest set with a professional, high-impact display from day one.',
  tags: [],
  msrpDollars: 1937.19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:05.299Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
